export default __webpack_public_path__ + "locales/ko-KR/People.json?hash=52cee9ecb82fb6f9944a9ff371e4123f";